import { render, staticRenderFns } from "./a-modal-confirmation.vue?vue&type=template&id=804b4410&scoped=true&"
import script from "./a-modal-confirmation.vue?vue&type=script&lang=js&"
export * from "./a-modal-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./a-modal-confirmation.vue?vue&type=style&index=0&id=804b4410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b4410",
  null
  
)

export default component.exports